// extracted by mini-css-extract-plugin
export default {"a":"styles_a__YN1bE","nav_link":"styles_nav_link__ntWUr","link_blue":"styles_link_blue__VQDrN"};